import  { useState } from "react";
import { motion } from "framer-motion";
import {
  AppBar,
  Toolbar,
  Container,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Avatar,
} from "@mui/material";
import { Menu, Close as X } from "@mui/icons-material";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          bgcolor: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(8px)",
          boxShadow: 1,
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
          position: "fixed !important",
          WebkitTransform: "translate3d(0,0,0)",
          transform: "translate3d(0,0,0)",
          willChange: "transform",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ minHeight: { xs: 64, md: 70 }, py: 1 }}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                flexGrow: 1,
                cursor: "pointer",
                userSelect: "none",
                WebkitTapHighlightColor: "transparent"
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState({}, '', '/');
              }}
              onTouchEnd={(e) => {
                e.preventDefault();
                e.stopPropagation();
                document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState({}, '', '/');
              }}
            >
              <Avatar
                src="./logo.png"
                variant="square"
                alt="SHREE CONSULTANCY"
                sx={{ width: 48, height: 56 }}
              />
              <Box>
                <Typography
                  variant="h5"
                  component="h1"
                  sx={{
                    fontWeight: "bold",
                    color: "rgba(30, 91, 92, 1)",
                    lineHeight: 1.1,
                    fontSize: { xs: '1.2rem', md: '1.5rem' },
                    "&:hover": { color: "rgba(30, 91, 92, 0.8)" }
                  }}
                >
                  SHREE CONSULTANCY
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", lineHeight: 1.1, fontSize: { xs: '0.8rem', md: '0.9rem' } }}
                >
                  Tax Consultant & Business Loan
                </Typography>
              </Box>
            </motion.div>
            {/* <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                flexGrow: 1,
              }}
            >
              <Link
                to="/"
                style={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                }}
              >
                <Avatar
                  src="./shree1.jpg"
                  variant="square"
                  alt="SHREE CONSULTANCY"
                  sx={{ width: 48, height: 56 }}
                />
                <Box>
                  <Typography
                    variant="h5"
                    component="h1"
                    sx={{
                      fontWeight: "bold",
                      color: "rgba(30, 91, 92, 1)",
                      lineHeight: 1.1,
                      fontSize: { xs: "1.2rem", md: "1.5rem" },
                    }}
                  >
                    SHREE CONSULTANCY
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "text.secondary",
                      lineHeight: 1.1,
                      fontSize: { xs: "0.8rem", md: "0.9rem" },
                    }}
                  >
                    Tax Consultant & Business Loan
                  </Typography>
                </Box>
              </Link>
            </motion.div> */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: 3,
              }}
            >
              <Button
                onClick={() => {
                  document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/');
                }}
                sx={{
                  color: "text.primary",
                  fontWeight: 500,
                  "&:hover": { color: "rgba(30, 91, 92, 1)" },
                }}
              >
                Home
              </Button>
              <Button
                onClick={() => {
                  document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/services');
                }}
                sx={{
                  color: "text.primary",
                  fontWeight: 500,
                  "&:hover": { color: "rgba(30, 91, 92, 1)" },
                }}
              >
                Services
              </Button>
              <Button
                onClick={() => {
                  document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/about');
                }}
                sx={{
                  color: "text.primary",
                  fontWeight: 500,
                  "&:hover": { color: "rgba(30, 91, 92, 1)" },
                }}
              >
                About
              </Button>
              <Button
                onClick={() => {
                  document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/testimonials');
                }}
                sx={{
                  color: "text.primary",
                  fontWeight: 500,
                  "&:hover": { color: "rgba(30, 91, 92, 1)" },
                }}
              >
                Testimonials
              </Button>
              <Button
                onClick={() => {
                  document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/faq');
                }}
                sx={{
                  color: "text.primary",
                  fontWeight: 500,
                  "&:hover": { color: "rgba(30, 91, 92, 1)" },
                }}
              >
                FAQ
              </Button>
              <Button
                onClick={() => {
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/contact');
                }}
                sx={{
                  color: "text.primary",
                  fontWeight: 500,
                  "&:hover": { color: "rgba(30, 91, 92, 1)" },
                }}
              >
                Contact
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  document.getElementById('loan-inquiry')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/loan-inquiry');
                }}
                sx={{
                  bgcolor: "rgba(30, 91, 92, 1)",
                  "&:hover": { bgcolor: "rgba(30, 91, 92, 0.8)" },
                }}
              >
                Apply for Loan
              </Button>
            </Box>

            <IconButton
              sx={{
                display: { xs: "block", md: "none" },
                color: "text.primary",
              }}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X /> : <Menu />}
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        anchor="top"
        open={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        sx={{ display: { xs: "block", md: "none" } }}
      >
        <Box sx={{ pt: 10, pb: 2 }}>
          <List>
            <ListItem
              button
              onClick={() => {
                document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState({}, '', '/');
                setIsMenuOpen(false);
              }}
            >
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState({}, '', '/services');
                setIsMenuOpen(false);
              }}
            >
              <ListItemText primary="Services" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState({}, '', '/about');
                setIsMenuOpen(false);
              }}
            >
              <ListItemText primary="About" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState({}, '', '/testimonials');
                setIsMenuOpen(false);
              }}
            >
              <ListItemText primary="Testimonials" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState({}, '', '/faq');
                setIsMenuOpen(false);
              }}
            >
              <ListItemText primary="FAQ" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                window.history.pushState({}, '', '/contact');
                setIsMenuOpen(false);
              }}
            >
              <ListItemText primary="Contact" />
            </ListItem>
            <ListItem>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  document.getElementById('loan-inquiry')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/loan-inquiry');
                  setIsMenuOpen(false);
                }}
                sx={{ bgcolor: "rgba(30, 91, 92, 1)" }}
              >
                Apply for Loan
              </Button>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
}
